<template>
    <div class="greybox">
        <h1>Your on-site repair booking information...</h1>
        <h4 class=" mt-5">The gadget</h4>
        <div class="claim-list-card">
            <div class="claim-list-card-body">
                <p><i :class="gadgetTypeIcon(selectedGadget.deviceTypeId)"></i> {{selectedGadget.displayName}}</p>
                <p><strong>Damage / repair:</strong> {{selectedGadget.damage}}</p>
            </div>
        </div>
        <h4 class=" mt-3">The appointment</h4>
        <div class="claim-list-card">
            <div class="claim-list-card-body">
                <p>{{selectedGadget.booking.appointmentDate}}</p>
                <p>You will be contacted on the day of the repair by our partner with a timeslot</p>
            </div>
        </div>
        <h4 class=" mt-3">The address</h4>
        <div class="claim-list-card">
            <div class="claim-list-card-body">
                <p>The repair will be carried out at the following address:</p>
                <div class="pl-5">
                    <p>{{addressLine1}}</p>
                    <p v-if="addressLine2">{{addressLine2}}</p>
                    <p>{{addressTown}}</p>
                    <p>{{addressPostcode}}</p>
                </div>
            </div>
        </div>
        <div class="button-fluid-container">
            <button class="button">Close</button>
            <button class="button" @click="cancelBooking({path: ''})">Cancel</button>
            <button class="button" @click="cancelBooking({path: '/myclaims/repairoptions/booking/'})">Cancel and book again</button>
        </div>
        
    </div>
</template>
<script>
import repairOptionsBase from '@/mixins/repairOptionsBase'

// TEMP!!
import { repairOptionsService } from '@/services/repairOptions-api.service'

export default {
    mixins: [
        repairOptionsBase
    ],
    computed: {
        providerBookingInfo () {
            let { booking } = this.selectedGadget
            if (booking != null) {
                return JSON.parse(booking.providerBookingInfo)
            }
            return null
        },
        providerBookingInfoAddress () {
            let { address } = this.providerBookingInfo
            if (address != null) {
                return address
            }
            return null
        },
        addressLine1 () {
            if (this.providerBookingInfoAddress != null) {
                return this.providerBookingInfoAddress.line_1
            }
            return null
        },
        addressLine2 () {
             if (this.providerBookingInfoAddress != null) {
                return this.providerBookingInfoAddress.line_2
            }
            return null
        },
        addressTown () {
             if (this.providerBookingInfoAddress != null) {
                return this.providerBookingInfoAddress.town
            }
            return null
        },
        addressPostcode () {
             if (this.providerBookingInfoAddress != null) {
                return this.providerBookingInfoAddress.postcode
            }
            return null
        },
        // gadgetRepairOptionTypeId () {
        //     let { repairOption } = this.selectedGadget
        //     if (repairOption != null) {
        //         let { repairOptionTypeId } = repairOption
        //         return repairOptionTypeId
        //     }
        //     return null
        //     },
        //     gadgetRepairBookingReference () {
        //     let { repairOption } = this.selectedGadget
        //     if (repairOption != null) {
        //         let { booking } = repairOption
        //         if (booking != null) {
        //         return booking.providerBookingRef
        //         }
        //     }
        //     return null
        //     },
        //     gadgetRepairBookingOrderId () {
        //     let { repairOption } = this.selectedGadget
        //     if (repairOption != null) {
        //         let { booking } = repairOption
        //         if (booking != null) {
        //         let { providerBookingInfo } = booking
        //         if (providerBookingInfo != null) {
        //             let infoJson = JSON.parse(providerBookingInfo)
        //             if (infoJson != null) {
        //             return infoJson.order_id
        //             }
        //         }
        //         }
        //     }
        //     return null
        //     }
    },
    methods: {
        cancelBooking (redirectTo) {
            repairOptionsService.CancelBooking(this.gadgetRepairBookingOrderId)
                .then( (response) => {
                    this.loadSelectedClaim(this.selectedGadgetId)
                    if (redirectTo) {
                        this.$router.push(redirectTo)
                    }
                })
        },
        gadgetTypeIcon (type) {
        switch (type) {
            case 1:
                return 'fas fa-mobile-alt'
                break
            case 2:
                return 'fas fa-tablet-alt'
                break
            case 3:
                return 'fas fa-laptop'
                break
            case 5:
                return 'fas fa-headphones'
                break
            case 6:
                return 'fas fa-gamepad'
                break
            case 7:
                return 'fas fa-gamepad'
                break
            case 8:
                return 'fas fa-camera'
                break
            case 9:
                return 'fas fa-camera'
                break
            case 10:
                return 'fas fa-video'
                break
            case 11:
                return 'fas fa-keyboard'
                break
            case 12:
                return 'fas fa-headphones'
                break
            case 13:
                return 'fas fa-compact-disc'
                break
            case 14:
                return 'fas fa-map-marked-alt'
                break
            case 15:
                return 'fas fa-car'
                break
            case 16:
                return 'fas fa-clock'
                break
            case 17:
                return 'fas fa-clock'
                break
            default:
                return 'fas fa-mobile-alt'
        }
        }
    }
}
</script>

